export enum PplusTreeMode {
    SINGLE = 'single',
    MULTIPLE = 'multiple'
}